import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel, Empty } from "@/components/PageHeader";
import { QuotaBars, useMsgUsage } from "@/components/MsgQuotaWidget";
import { RechargeRequestButton } from "@/components/RechargeRequest";
import { api, errMsg, fdatetime } from "@/lib/api";

const eur = (v) => `${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const CH = { email: "Email", sms: "SMS", whatsapp: "WhatsApp" };

export const downloadFile = async (url, params, name) => {
  try {
    const r = await api.get(url, { params, responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = name; a.click();
  } catch { toast.error("Esportazione non riuscita"); }
};

export const MyLedger = () => {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  const [usage] = useMsgUsage();
  useEffect(() => { api.get("/me/msg-ledger", { params: { month } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [month]);
  const me = d?.rows?.[0];
  return (
    <Panel title="La mia contabilità messaggi" testId="my-ledger-panel" className="mt-6"
      action={<div className="flex items-center gap-2"><Input type="month" className="h-8 w-40" data-testid="my-ledger-month" value={month} onChange={(e) => setMonth(e.target.value)} />
        <Button size="sm" variant="outline" data-testid="my-ledger-xlsx" disabled={!me} onClick={() => downloadFile("/me/msg-ledger/export", { month, fmt: "xlsx" }, `contabilita-messaggi-${month}.xlsx`)}><Download className="mr-1.5 h-4 w-4" />Excel</Button>
        <Button size="sm" variant="outline" data-testid="my-ledger-pdf" disabled={!me} onClick={() => downloadFile("/me/msg-ledger/export", { month, fmt: "pdf" }, `contabilita-messaggi-${month}.pdf`)}><FileText className="mr-1.5 h-4 w-4" />PDF</Button></div>}>
      <div className="grid gap-5 p-5 lg:grid-cols-[260px_1fr]">
        <div>
          <div className="mb-2 text-xs font-semibold text-slate-700">Plafond {usage?.profile?.mode === "recharge" ? "del pacchetto" : "del mese"}{usage?.profile_name ? ` · ${usage.profile_name}` : ""}</div>
          <QuotaBars usage={usage} />
          {usage?.profile && <p className="mt-3 text-[11px] text-slate-400">Avviso dal {usage.profile.warn_pct}% del plafond. I consensi del cliente vengono comunque verificati a ogni invio.</p>}
          <RechargeRequestButton usage={usage} />
        </div>
        <div>
          {!d ? <div className="text-sm text-slate-400">Caricamento...</div> : !me ? <Empty text="Nessun messaggio inviato in questo mese." /> : (
            <>
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid="my-ledger-kpis">
                {[["Email", me.email_qty], ["SMS", me.sms_qty], ["WhatsApp", me.whatsapp_qty], ["Costo", eur(me.cost)]].map(([l, v]) => <div key={l} className="rounded-lg border border-slate-200 bg-slate-50 p-3"><div className="text-[11px] text-slate-500">{l}</div><div className="font-heading text-lg font-semibold text-slate-900">{v}</div></div>)}
              </div>
              <div className="mt-4 max-h-72 divide-y divide-slate-100 overflow-auto rounded-lg border border-slate-200" data-testid="my-ledger-entries">
                {d.entries.map((e) => (
                  <div key={e.id} className="flex items-center justify-between gap-3 px-3 py-2 text-xs">
                    <div className="min-w-0"><b>{CH[e.channel]}</b> · {e.kind}{e.label ? ` · ${e.label}` : ""}<div className="text-slate-400">{fdatetime(e.created_at)}</div></div>
                    <div className="shrink-0 text-right tabular-nums"><div>{e.qty} × {e.unit_cost} €</div><div className="font-semibold text-slate-800">{eur(e.cost)}</div></div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </Panel>
  );
};
